export default function ConditionalWrapper(props) {
  return props.condition ? props.wrapper(props.children) : props.children
}
